import { createSelector } from 'reselect';
import { getCustomer, getCompany } from '../ducks';

export const getCustomerOrCompany = createSelector(getCustomer, getCompany, (customer, company) => customer || company);
